"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchApiClient = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var RecExperiment = __importStar(require("icf-search-client-shared/lib/services/RecommenderExperiment"));
var LoggerService_1 = require("icf-search-client-shared/lib/services/LoggerService");
var StatsDClient_1 = require("icf-search-client-shared/lib/services/StatsDClient");
var PerformerFallback = __importStar(require("./PerformerFallback"));
var TTLCache_1 = require("./cache/TTLCache");
var QueryParameter_1 = require("./QueryParameter");
var SearchFilters_1 = require("./SearchFilters");
var GatewayService_1 = require("./services/GatewayService");
var SEARCH_API_GATEWAY_GUID = "da48cfde-b78e-4dca-bd12-d6660fcccf2d";
var SearchApiClient = /** @class */ (function () {
    function SearchApiClient(domain, headers, defaultSearchKeywordIdsOverride, browseConfigVersionOverride, searchBoostedFilterOverride, isGoldOnlyMode, sakey, modelVersion, index, xments) {
        if (xments === void 0) { xments = {
            useSearchSnapshot: false,
            shouldTranslateSearches: false,
            useActualCountryForRegionalBoost: false,
            searchFreeAccountSignUpTile: false,
            searchReplaceLegacyBaseScore: false,
            loggedInRec: "NON_PARTICIPANT",
            loggedOutRec: -1,
            applyRegionalBoost: false,
        }; }
        this._gatewayCaller = (0, GatewayService_1.usingGateway)(SEARCH_API_GATEWAY_GUID);
        this._cacheTTLSeconds = 1;
        this._domain = domain;
        this._headers = headers;
        this._sakey = sakey;
        this._modelVersion = modelVersion;
        this._endpoints = {
            autocomplete: "/v4/autocomplete",
            byIds: "/v4/by-ids",
            contest: "/v4/contest",
            favorites: "/v4/favorites",
            keyword: "/v4/search",
            list: "/v4/performers",
            weights: "/v1/weights",
            publicPerformers: "/v4/performers/public",
        };
        this._index = index;
        this._defaultSearchKeywordIdsOverride = defaultSearchKeywordIdsOverride;
        this._browseConfigVersionOverride = browseConfigVersionOverride;
        this._searchBoostedFilterOverride = searchBoostedFilterOverride;
        this._isGoldOnlyMode = isGoldOnlyMode;
        this._cache = TTLCache_1.TTLCache.getInstance();
        this._useSearchSnapshot = !!(xments === null || xments === void 0 ? void 0 : xments.useSearchSnapshot);
        this._shouldTranslateSearches = !!(xments === null || xments === void 0 ? void 0 : xments.shouldTranslateSearches);
        this._useActualCountryForRegionalBoost = !!(xments === null || xments === void 0 ? void 0 : xments.useActualCountryForRegionalBoost);
        this._searchFreeAccountSignUpTile = !!(xments === null || xments === void 0 ? void 0 : xments.searchFreeAccountSignUpTile);
        this._searchReplaceLegacyBaseScore = !!(xments === null || xments === void 0 ? void 0 : xments.searchReplaceLegacyBaseScore);
        this._loggedInRec = xments === null || xments === void 0 ? void 0 : xments.loggedInRec;
        this._applyRegionalBoost = xments === null || xments === void 0 ? void 0 : xments.applyRegionalBoost;
    }
    SearchApiClient.prototype._get = function (endpoint, config) {
        return __awaiter(this, void 0, void 0, function () {
            var key, start, url, resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        key = endpoint.replaceAll("/", "_").replace(/^_/, "").replace(/_$/, "");
                        StatsDClient_1.statsd.count("search.endpoint.".concat(key));
                        start = performance.now();
                        url = this._getFullUrl(endpoint);
                        return [4 /*yield*/, this._gatewayCaller.get(__assign(__assign({}, config), { url: url })).catch(function (err) {
                                LoggerService_1.logger.error("unexpected error calling search from the client!", err);
                                StatsDClient_1.statsd.count("search.endpoint.".concat(key, ".error"));
                                throw err;
                            })];
                    case 1:
                        resp = _a.sent();
                        StatsDClient_1.statsd.count("search.endpoint.".concat(key, ".status_").concat(resp.status));
                        StatsDClient_1.statsd.timing("search.endpoint.".concat(key), performance.now() - start);
                        return [2 /*return*/, resp];
                }
            });
        });
    };
    SearchApiClient.prototype._getFullUrl = function (endpoint) {
        var result = endpoint;
        if (!this._sakey) {
            result += "/guest";
        }
        return result;
    };
    // TODO: All of this params stuff needs to be typed.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    SearchApiClient.prototype._getParams = function (from, pageIndex, pageSize, params) {
        return __awaiter(this, void 0, void 0, function () {
            var loggedInRec, newParams;
            return __generator(this, function (_a) {
                loggedInRec = this._loggedInRec && this._loggedInRec !== "NON_PARTICIPANT" ? this._loggedInRec : undefined;
                newParams = __assign({ domain: this._domain, from: from !== null && from !== void 0 ? from : pageIndex * pageSize, size: pageSize, modelVersion: this._modelVersion, loggedInRec: loggedInRec, defaultSearchKeywordIdsOverride: this._defaultSearchKeywordIdsOverride
                        ? this._defaultSearchKeywordIdsOverride
                        : undefined, browseConfigVersionOverride: this._browseConfigVersionOverride ? this._browseConfigVersionOverride : undefined, searchBoostedFilterOverride: this._searchBoostedFilterOverride ? this._searchBoostedFilterOverride : undefined, useSearchSnapshot: this._useSearchSnapshot ? this._useSearchSnapshot : undefined, shouldTranslateSearches: this._shouldTranslateSearches ? this._shouldTranslateSearches : undefined, useActualCountryForRegionalBoost: this._useActualCountryForRegionalBoost
                        ? this._useActualCountryForRegionalBoost
                        : undefined, searchFreeAccountSignUpTile: this._searchFreeAccountSignUpTile ? this._searchFreeAccountSignUpTile : undefined, searchReplaceLegacyBaseScore: this._searchReplaceLegacyBaseScore ? this._searchReplaceLegacyBaseScore : undefined, applyRegionalBoost: this._applyRegionalBoost ? this._applyRegionalBoost : undefined }, params);
                if (this._sakey) {
                    newParams.variation = loggedInRec;
                }
                return [2 /*return*/, newParams];
            });
        });
    };
    SearchApiClient.prototype._getCacheKey = function (endpoint, params) {
        return endpoint + JSON.stringify(params);
    };
    SearchApiClient.prototype._getPerformersFromCache = function (endpoint_1, _a, params_1) {
        return __awaiter(this, arguments, void 0, function (endpoint, _b, params) {
            var finalParams, _c, cacheKey;
            var from = _b.from, pageIndex = _b.pageIndex, pageSize = _b.pageSize;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(endpoint === this._endpoints.contest)) return [3 /*break*/, 1];
                        _c = params;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this._getParams(from, pageIndex, pageSize, params)];
                    case 2:
                        _c = _d.sent();
                        _d.label = 3;
                    case 3:
                        finalParams = _c;
                        cacheKey = this._getCacheKey(endpoint, finalParams);
                        if (!this._cache.has(cacheKey)) {
                            this._cache.set(cacheKey, this._getPerformers(endpoint, { pageIndex: pageIndex, pageSize: pageSize }, finalParams), this._cacheTTLSeconds);
                        }
                        return [2 /*return*/, this._cache.get(cacheKey)];
                }
            });
        });
    };
    SearchApiClient.prototype._getPerformers = function (endpoint_1, _a, params_1) {
        return __awaiter(this, arguments, void 0, function (endpoint, _b, params) {
            var headers, response, errors, loggedOutFromServer;
            var _this = this;
            var _c, _d, _e, _f, _g, _h, _j, _k;
            var pageIndex = _b.pageIndex, pageSize = _b.pageSize;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        headers = __assign({}, this._headers);
                        if (this._sakey) {
                            headers.sakey = this._sakey;
                        }
                        return [4 /*yield*/, this._get(endpoint, {
                                params: params,
                                headers: headers,
                            }).catch(function (error) {
                                // TODO: Test needs to be rewritten to not use mocks with cross-test lifecycles in order to simulate this case.
                                /* istanbul ignore next */
                                throw new Error("request to ".concat(_this._getFullUrl(endpoint), " failed, cause: ").concat(error, ". Params: ").concat(JSON.stringify(params), ". Headers: ").concat(JSON.stringify(headers)));
                            })];
                    case 1:
                        response = _l.sent();
                        errors = response.data.errors !== undefined ? response.data.errors : [];
                        if (((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.algorithm) === null || _d === void 0 ? void 0 : _d.variation) && ((_f = (_e = response.data) === null || _e === void 0 ? void 0 : _e.algorithm) === null || _f === void 0 ? void 0 : _f.name) === "loggedOutRec") {
                            loggedOutFromServer = (_h = (_g = response.data) === null || _g === void 0 ? void 0 : _g.algorithm) === null || _h === void 0 ? void 0 : _h.variation;
                        }
                        else if ((_j = response.data) === null || _j === void 0 ? void 0 : _j.loggedOutRec) {
                            loggedOutFromServer = (_k = response.data) === null || _k === void 0 ? void 0 : _k.loggedOutRec;
                        }
                        return [2 /*return*/, {
                                pageIndex: pageIndex,
                                pageSize: pageSize,
                                totalItems: response.data.totalResultCount,
                                totalOnlineItems: response.data.totalOnlineCount,
                                // We're creating a hasDetails value here if not explicitly false.
                                results: this._addHasDetailsIfNotFalse(response.data.performers),
                                index: params.index ? params.index : "none",
                                currentError: response.status >= 400 ? "response code is ".concat(response.status) : undefined,
                                errors: errors,
                                loggedOutFromServer: loggedOutFromServer,
                            }];
                }
            });
        });
    };
    SearchApiClient.prototype._getFallbackPerformers = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, PerformerFallback.getFallback()];
                    case 2:
                        result = _a.sent();
                        if (!result) {
                            LoggerService_1.logger.error("failed to get fallback performers");
                            StatsDClient_1.statsd.count("recommenders.fallback.error");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        LoggerService_1.logger.error("failed to get fallback performers", err_1);
                        StatsDClient_1.statsd.count("recommenders.fallback.error");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    SearchApiClient.prototype._fetchPerformersWithFallback = function (pageOptions, params) {
        return __awaiter(this, void 0, void 0, function () {
            var response, error_1, loggedOutFromServer;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        // Refresh fallback state (don't await - let it run in background)
                        this._getFallbackPerformers();
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this._get(this._endpoints.list, {
                                params: params,
                                headers: this._headers,
                            })];
                    case 2:
                        response = _e.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _e.sent();
                        LoggerService_1.logger.error("request to ".concat(this._getFullUrl(this._endpoints.list), " failed. Using fallback."), error_1);
                        StatsDClient_1.statsd.count("recommenders.fallback.trigger");
                        return [4 /*yield*/, this._getFallbackPerformers()];
                    case 4:
                        response = _e.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        loggedOutFromServer = this._extractLoggedOutFromServer((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.algorithm, (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.loggedOutRec);
                        return [2 /*return*/, {
                                pageIndex: pageOptions.pageIndex,
                                pageSize: pageOptions.pageSize,
                                totalItems: response === null || response === void 0 ? void 0 : response.data.totalResultCount,
                                totalOnlineItems: response === null || response === void 0 ? void 0 : response.data.totalOnlineCount,
                                results: this._addHasDetailsIfNotFalse(response === null || response === void 0 ? void 0 : response.data.performers),
                                index: "none",
                                currentError: (response === null || response === void 0 ? void 0 : response.status) !== 200 ? "response code is ".concat(response === null || response === void 0 ? void 0 : response.status) : undefined,
                                errors: (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.errors) !== null && _d !== void 0 ? _d : [],
                                loggedOutFromServer: loggedOutFromServer,
                            }];
                }
            });
        });
    };
    SearchApiClient.prototype._extractLoggedOutFromServer = function (algorithm, loggedOutRec) {
        var loggedOutFromServer = loggedOutRec !== null && loggedOutRec !== void 0 ? loggedOutRec : undefined;
        if ((algorithm === null || algorithm === void 0 ? void 0 : algorithm.variation) && (algorithm === null || algorithm === void 0 ? void 0 : algorithm.name) === "loggedOutRec") {
            loggedOutFromServer = algorithm === null || algorithm === void 0 ? void 0 : algorithm.variation;
        }
        return loggedOutFromServer;
    };
    SearchApiClient.prototype._getPerformersWithFallback = function (pageOptions, params) {
        return __awaiter(this, void 0, void 0, function () {
            var from, pageIndex, pageSize, finalParams, cacheKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        from = pageOptions.from, pageIndex = pageOptions.pageIndex, pageSize = pageOptions.pageSize;
                        return [4 /*yield*/, this._getParams(from, pageIndex, pageSize, params)];
                    case 1:
                        finalParams = _a.sent();
                        cacheKey = this._getCacheKey(this._endpoints.list, finalParams);
                        if (!this._cache.has(cacheKey)) {
                            this._cache.set(cacheKey, this._fetchPerformersWithFallback(pageOptions, finalParams), this._cacheTTLSeconds);
                        }
                        return [2 /*return*/, this._cache.get(cacheKey)];
                }
            });
        });
    };
    SearchApiClient.prototype._stripOnlineFilterFromGoldOnly = function (filters) {
        if (!filters) {
            return filters;
        }
        var modifiedFilters = __assign({}, filters);
        if (this._isGoldOnlyMode) {
            delete modifiedFilters.online;
        }
        return modifiedFilters;
    };
    SearchApiClient.prototype.getPerformerList = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pageOptions, useLoggedoutRec;
            return __generator(this, function (_a) {
                params = __assign(__assign({}, (0, SearchFilters_1.getSplitFiltersWithAllFilterTypes)({
                    filters: this._stripOnlineFilterFromGoldOnly(options.filters),
                    excludedFilters: options.excludedFilters,
                    notExactBoostedFilters: options.notExactBoostedFilters,
                })), { country: options.country, language: options.language, index: this._index, genderSetting: options.genderSetting, includeFavorites: options.includeFavorites });
                pageOptions = {
                    pageIndex: options.pageIndex,
                    from: options.from,
                    pageSize: options.pageSize,
                };
                useLoggedoutRec = !this._sakey;
                return [2 /*return*/, useLoggedoutRec
                        ? this.getLoggedoutRecommenderPerformers(pageOptions, params)
                        : this._getPerformersWithFallback(pageOptions, params)];
            });
        });
    };
    SearchApiClient.prototype.getLoggedoutRecommenderPerformers = function (options, params) {
        return __awaiter(this, void 0, void 0, function () {
            var experimentName, newParams, _a, loggedOutFromServer, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        experimentName = RecExperiment.getLoggedOutRec();
                        newParams = __assign({ algo: "loggedout", loggedOutRec: experimentName !== null && experimentName !== void 0 ? experimentName : "fallback" }, params);
                        if (experimentName) {
                            newParams.variation = experimentName;
                        }
                        return [4 /*yield*/, this._getPerformersWithFallback(options, newParams)];
                    case 1:
                        _a = _b.sent(), loggedOutFromServer = _a.loggedOutFromServer, response = __rest(_a, ["loggedOutFromServer"]);
                        if (!!RecExperiment.EXPERIMENT_WEIGHTS.names.includes(experimentName)) return [3 /*break*/, 3];
                        return [4 /*yield*/, RecExperiment.clearLoggedOutRecommender()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/, response];
                }
            });
        });
    };
    SearchApiClient.prototype.getPerformersInContest = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._getPerformersFromCache(this._endpoints.contest, options, {
                        contestId: options.contestId,
                        contestOnlyAvailable: options.contestFilter === "available",
                        from: options.from === undefined ? options.pageIndex * options.pageSize : options.from,
                        size: options.pageSize,
                    })];
            });
        });
    };
    SearchApiClient.prototype.getKeywordSearch = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._getPerformersFromCache(this._endpoints.keyword, options, __assign(__assign({}, (0, SearchFilters_1.getSplitFilters)(this._stripOnlineFilterFromGoldOnly(options.filters))), { query: options.keyword, index: this._index }))];
            });
        });
    };
    SearchApiClient.prototype._getV3CategoryFilters = function (categoryName) {
        switch (categoryName) {
            case "new":
                return {
                    new: {
                        value: "new",
                        label: "",
                        filters: [{ name: "new", value: true, isBoosted: false }],
                    },
                };
            case "gold":
                return {
                    goldshow: {
                        value: "gold",
                        label: "",
                        filters: [
                            {
                                name: "livestate",
                                value: "goldshow,pregoldshow",
                                isBoosted: false,
                            },
                        ],
                    },
                };
            case "allcams":
            case "alltrans":
                return {};
            case "allgirls":
                return {
                    gender: {
                        value: "f",
                        label: "",
                        filters: [{ name: "gender", value: "f", isBoosted: false }],
                    },
                };
            default:
                return {
                    category: {
                        value: "category",
                        label: "",
                        filters: [{ name: "category", value: categoryName, isBoosted: false }],
                    },
                };
        }
    };
    SearchApiClient.prototype.getPerformersInCategory = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var categoryName, filtersWithCategories, params, useLoggedoutRec;
            return __generator(this, function (_a) {
                categoryName = options.categoryName;
                filtersWithCategories = __assign(__assign({}, this._getV3CategoryFilters(categoryName)), this._stripOnlineFilterFromGoldOnly(options.filters));
                // Gender is baked into the couples category, only M primary, F secondary
                // or F primary, M secondary are assigned this category. Filtering with gender
                // causes issues with showing MF streams in the girls/couples category.
                if (categoryName === "couples") {
                    delete filtersWithCategories.gender;
                }
                params = __assign(__assign({}, (0, SearchFilters_1.getSplitFilters)(filtersWithCategories)), { country: options.country, language: options.language, index: this._index });
                useLoggedoutRec = !this._sakey && RecExperiment.loggedOutRecIsValid();
                return [2 /*return*/, useLoggedoutRec
                        ? this.getLoggedoutRecommenderPerformers(options, params)
                        : this._getPerformersFromCache(this._endpoints.list, options, params)];
            });
        });
    };
    SearchApiClient.prototype._getFavoritesParams = function (options) {
        var splitFilters = (0, SearchFilters_1.splitOutBoostedFilters)((0, SearchFilters_1.getFilterArray)(options.filters));
        return {
            filters: (0, SearchFilters_1.formatFilters)(splitFilters.unboostedFilters),
            index: this._index,
        };
    };
    SearchApiClient.prototype.getFavoritePerformers = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._getPerformersFromCache(this._endpoints.favorites, options, this._getFavoritesParams(options))];
            });
        });
    };
    SearchApiClient.prototype.getPerformersByIds = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var pageIndex, pageSize, performerIds, startIndex, validPerformerIds, performerIdsInPage, params, headers, response, results, ranking;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pageIndex = options.pageIndex, pageSize = options.pageSize, performerIds = options.performerIds;
                        startIndex = pageIndex * pageSize;
                        validPerformerIds = performerIds.filter(function (id) { return !!id; });
                        if (validPerformerIds.length === 0) {
                            return [2 /*return*/, {
                                    pageIndex: options.pageIndex,
                                    pageSize: options.pageSize,
                                    totalItems: 0,
                                    results: [],
                                }];
                        }
                        performerIdsInPage = validPerformerIds.slice(startIndex, startIndex + pageSize);
                        if (performerIdsInPage.length === 0) {
                            return [2 /*return*/, {
                                    pageIndex: options.pageIndex,
                                    pageSize: options.pageSize,
                                    totalItems: validPerformerIds.length,
                                    results: [],
                                }];
                        }
                        params = {
                            performerIds: performerIdsInPage.join(","),
                        };
                        headers = __assign({}, this._headers);
                        if (this._sakey) {
                            headers.sakey = this._sakey;
                        }
                        return [4 /*yield*/, this._get(this._endpoints.byIds, {
                                params: params,
                                headers: headers,
                            })];
                    case 1:
                        response = _a.sent();
                        results = this._addHasDetailsIfNotFalse(response.data.performers);
                        ranking = Object.fromEntries(performerIdsInPage.map(function (id, i) { return [id, i]; }));
                        results.sort(function (a, b) { return ranking[a.id] - ranking[b.id]; });
                        return [2 /*return*/, {
                                pageIndex: options.pageIndex,
                                pageSize: options.pageSize,
                                totalItems: validPerformerIds.length,
                                results: results,
                            }];
                }
            });
        });
    };
    SearchApiClient.prototype._addHasDetailsIfNotFalse = function (performers) {
        return performers.map(function (p) { return (p.hasDetails !== false ? __assign({ hasDetails: true }, p) : p); });
    };
    SearchApiClient.prototype._getAutocompleteParams = function (_a) {
        var query = _a.query, performerCount = _a.performerCount, tagCount = _a.tagCount, genderFilter = _a.genderFilter;
        return {
            filters: genderFilter ? "".concat(genderFilter.name, ":").concat(genderFilter.value) : "",
            performerCount: performerCount,
            domain: this._domain,
            tagCount: tagCount,
            query: new QueryParameter_1.QueryParameter(query).encode(),
            defaultSearchKeywordIdsOverride: this._defaultSearchKeywordIdsOverride
                ? this._defaultSearchKeywordIdsOverride
                : undefined,
            browseConfigVersionOverride: this._browseConfigVersionOverride ? this._browseConfigVersionOverride : undefined,
            searchBoostedFilterOverride: this._searchBoostedFilterOverride ? this._searchBoostedFilterOverride : undefined,
            useSearchSnapshot: this._useSearchSnapshot ? this._useSearchSnapshot : undefined,
            shouldTranslateSearches: this._shouldTranslateSearches ? this._shouldTranslateSearches : undefined,
        };
    };
    SearchApiClient.prototype.getFreeAccountTileXment = function () {
        return this._searchFreeAccountSignUpTile;
    };
    SearchApiClient.prototype.getAutocomplete = function (_a) {
        return __awaiter(this, arguments, void 0, function (_b) {
            var headers, result, resultTags, items;
            var query = _b.query, performerCount = _b.performerCount, tagCount = _b.tagCount, genderFilter = _b.genderFilter;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!query || query.length === 0) {
                            return [2 /*return*/, {
                                    results: [],
                                    totalItems: 0,
                                    totalOnlineItems: 0,
                                }];
                        }
                        headers = __assign({}, this._headers);
                        if (this._sakey) {
                            headers.sakey = this._sakey;
                        }
                        return [4 /*yield*/, this._get(this._endpoints.autocomplete, {
                                headers: headers,
                                params: this._getAutocompleteParams({
                                    query: query,
                                    performerCount: performerCount,
                                    tagCount: tagCount,
                                    genderFilter: genderFilter,
                                }),
                            })];
                    case 1:
                        result = (_c.sent()).data;
                        resultTags = result.tags ? result.tags : [];
                        items = __spreadArray(__spreadArray([], __read(result.performers.slice(0, performerCount).map(function (p) { return ({
                            type: "performer",
                            performer: p,
                        }); })), false), __read(resultTags.slice(0, tagCount).map(function (t) { return ({ type: "tag", tag: t }); })), false);
                        return [2 /*return*/, {
                                results: items,
                                totalItems: items.length,
                            }];
                }
            });
        });
    };
    return SearchApiClient;
}());
exports.SearchApiClient = SearchApiClient;
//# sourceMappingURL=SearchApiClient.js.map